import { gigyaInstance } from '@ciam/async-utils';
import { createGigyaPromise } from '../utils';
export const GigyaAPI = {
    accounts: {
        login: async (params) => {
            const { data } = await gigyaInstance.post('/accounts.login', params);
            return data;
        },
        socialLogin: createGigyaPromise(() => window.gigya.accounts.socialLogin),
        getAccountInfo: createGigyaPromise(() => window.gigya.accounts.getAccountInfo),
        resetPassword: createGigyaPromise(() => window.gigya.accounts.resetPassword),
        setAccountInfo: createGigyaPromise(() => window.gigya.accounts.setAccountInfo),
        finalizeRegistration: createGigyaPromise(() => window.gigya.accounts.finalizeRegistration),
    },
    socialize: {
        notifyLogin: createGigyaPromise(() => window.gigya.socialize.notifyLogin),
    },
    continueSSO: async () => await window.gigya.fidm.saml.continueSSO,
};
//# sourceMappingURL=index.js.map